export default {"src":"/_next/static/media/testimonialCardShape.d61d9c4a.svg","height":197,"width":328,"blurWidth":0,"blurHeight":0};